import React from 'react';
import '../../styles/AssociationStory.css';
import { FaHistory, FaMapMarkedAlt, FaRocket } from 'react-icons/fa';

const AssociationStory = () => {
  return (
    <section className="story-section">
      <div className="story-container">
        
        {/* En-tête de section */}
        <div className="story-header">
          <h2 className="story-title">Notre Histoire</h2>
          <p className="story-subtitle">
            D'un simple groupe Facebook de quartier à une plateforme nationale d'aide au logement.
          </p>
        </div>

        <div className="story-content">
          
          {/* Bloc Gauche : L'explication du nom */}
          <div className="story-text">
            <h3>Pourquoi garder <span className="highlight-06">NMS 06</span> ?</h3>
            <p>
              En 2020, en plein confinement, tout a commencé dans le quartier des Moulins à Nice (06). 
              Face à l'isolement, nous avons créé un lien solidaire unique.
            </p>
            <p>
              Aujourd'hui, nos méthodes ont fait leurs preuves et dépassent les frontières du département. 
              Nous avons choisi de garder notre nom historique, mais avec une nouvelle ambition :
            </p>
            
            <div className="rebrand-box">
              <span className="old-meaning">Nice Moulins Solidarités</span>
              <span className="arrow">➜</span>
              <span className="new-meaning">Nouvelles Méthodes Solidaires</span>
            </div>
            
            <p className="story-conclusion">
              Le "06", c'est notre ADN, notre racine. Mais notre action, elle, est désormais sans frontières.
            </p>
          </div>

          {/* Bloc Droite : La Timeline verticale */}
          <div className="story-timeline">
            
            {/* Étape 1 */}
            <div className="timeline-item">
              <div className="timeline-icon"><FaHistory /></div>
              <div className="timeline-content">
                <h4>2020 : La Genèse</h4>
                <p>Création d'un groupe d'entraide et de la "Radio des Moulins" pour briser l'isolement du confinement.</p>
              </div>
            </div>

            {/* Étape 2 */}
            <div className="timeline-item">
              <div className="timeline-icon"><FaMapMarkedAlt /></div>
              <div className="timeline-content">
                <h4>2022 : L'Expertise Terrain</h4>
                <p>L'association structure ses actions juridiques. Les premières victoires contre l'insalubrité sont remportées.</p>
              </div>
            </div>

            {/* Étape 3 */}
            <div className="timeline-item active-step">
              <div className="timeline-icon"><FaRocket /></div>
              <div className="timeline-content">
                <h4>Aujourd'hui : L'IA au service de tous</h4>
                <p>NMS 06 ouvre ses outils numériques aux propriétaires et locataires de toute la France.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AssociationStory;